import {registerRoutes, registerStores} from 'mutants-microfx';
import routers from './routers';
import stores from './stores';
import './styles/index.less';
registerRoutes(routers);
registerStores(stores);

//注册登录信息
// setLoginParam({indexPage:'querySchemePortal',username:'17001098922',password:'795878',accountFilter:['2019_06']});
//输出
export SearchPageView from  './module_biz/QueryScheme/view/SearchPageView';
export RefPageView from  './module_biz/QueryScheme/view/RefPageView';
export SearchPage from './module_biz/QueryScheme/page/SearchPage';
export RefPage from './module_biz/QueryScheme/page/RefPage'; 


